module.exports = {
	events: {
		filter: {
			type: 'change',
			selector: 'select[name="category"]',
			action: function(event){
				var self = event.data.component;
				var value = event.target.value || 'all';
				var odd = true;
				self.$.find('tr').each(function(){
					var $this = $(this);
					var catID = $this.data('catId');
					$this.removeClass('hidden even odd')
					if(value === 'all' || catID == value){
						if(odd) {
							$(this).addClass('odd');
						} else {
							$(this).addClass('even');
						}
						odd = !odd;
					} else {
						$this.addClass('hidden')
					}
				});
			}
		}
	}
}